import React from 'react';
import { Chip } from '@mui/material';
import { CREW_CLEARANCE_CONFIG } from '../../../../utils/crewClearance';

const chipSx = { height: 22, fontSize: '0.65rem', fontWeight: 600 };

const CrewClearanceChips = ({ crew, size = 'small' }) => (
  <>
    {CREW_CLEARANCE_CONFIG.map(({ field, label }) =>
      crew?.[field] === true ? (
        <Chip
          key={field}
          size={size}
          label={label}
          color="secondary"
          variant="outlined"
          sx={chipSx}
        />
      ) : null
    )}
  </>
);

export default CrewClearanceChips;
